import { useState } from 'react';
import { Modal, Button, Form, Upload, Divider } from 'antd';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import ImgCrop from 'antd-img-crop';
import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface';

const normFile = (e: any) => {
  if (Array.isArray(e)) {
    return e;
  }
};

const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

const FormImage = (props: { name: string, nombre: number, label: string, form?: any, type: string, required?: boolean }) => {

  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  var [previewImage, setPreviewImage] = useState<any>();
  const [previewTitle, setPreviewTitle] = useState('');

  const onChange: UploadProps['onChange'] = async ({ fileList: newFileList }) => {
    setFileList(newFileList);
    if (newFileList[0]?.originFileObj) {
      let file = await getBase64(newFileList[0].originFileObj as RcFile);
      props.form.setFieldValue(props.name, file);
    }

  };

  const handleCancel = () => setPreviewOpen(false);
  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as RcFile);
    }
    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
  };

  const handlePdf = async (file: UploadFile) => {
    var filep = await getBase64(file as RcFile);
    setPreviewImage(filep);
    setPreviewOpen(true);

  };

  if (props.type === 'image') {
    return (
      <>
        <Form.Item rules={[{ required: props.required, message: "" }]} getValueFromEvent={normFile} name={props.name} >
          <Upload
            listType="picture-card"
            onChange={e => { onChange(e) }}
            onPreview={handlePreview}
            maxCount={props.nombre}
          >
            {fileList.length < 1 && '+ ' + props.label}

          </Upload>
        </Form.Item>

        <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </>);
  }
  else {
    return (
      <>
        <Form.Item rules={[{ required: props.required, message: "" }]} getValueFromEvent={normFile} name={props.name} >
          <Upload
            accept='.pdf'
            listType="picture-card"
            onChange={e => { onChange(e) }}
            onPreview={handlePreview}
            maxCount={props.nombre}
            beforeUpload={e => { handlePdf(e) }}
          >
            {fileList.length < 1 && '+ ' + props.label}
          </Upload>
          <Dialog open={previewOpen} title={previewTitle} >
            <DialogTitle>Preview File</DialogTitle>
            <DialogContent>
              <embed width="900" height="500" type="application/pdf" src={previewImage} />
            </DialogContent>
            <DialogActions>
              <Button type='default' color='red' onClick={() => { setPreviewOpen(false) }}>Fermer</Button>
            </DialogActions>
          </Dialog>
        </Form.Item>
      </>);

  }
}


export default FormImage;